import { render, staticRenderFns } from "./BookSeriesList.vue?vue&type=template&id=edff62a6&scoped=true"
import script from "./BookSeriesList.vue?vue&type=script&lang=js"
export * from "./BookSeriesList.vue?vue&type=script&lang=js"
import style0 from "./BookSeriesList.vue?vue&type=style&index=0&id=edff62a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff62a6",
  null
  
)

export default component.exports